import {
  EVENT_GET,
  EVENT_LOADING,
  EVENT_STREAMS,
  EVENT_REMOVE_STREAM_LOCAL,
  EVENT_UPDATE,
  EVENTS_DONATIONS_SET_ID,
  DONATIONS_LOADING
} from 'types/actions/event'
import API from 'store/api'
import serialize from 'store/serialize'
import { EVENT_GET_STATS } from 'types/actions/event'
import { EVENT_SET_DONATIONS } from 'types/actions/event'
import { EVENT_DONATIONS_PUSH } from 'types/actions/event'
import { EVENT_DONATIONS_REMOVE } from 'types/actions/event'
import { EVENT_SET_CHATS, EVENT_SET_CHATS_LOADING } from 'types/actions/event'
import { orderBy, set } from 'lodash'
import { EVENT_PUSH_CHATS } from 'types/actions/event'
import { EVENT_TICKETS_SET } from 'types/actions/event'
import { EVENT_TICKETS_LOADING } from 'types/actions/event'
import { MY_TICKETS_SET } from 'types/actions/event'
import { MY_TICKETS_LOADING } from 'types/actions/event'
import { EVENT_REMOVE_MESSAGE } from 'types/actions/event'

export const setDonationsLoading = donationsLoading => ({
  type: DONATIONS_LOADING,
  donationsLoading
})

export const setEvent = event => ({
  type: EVENT_GET,
  event
})

export const updateEventData = event => ({
  type: EVENT_UPDATE,
  event
})

export const updateEventStreams = streams => ({
  type: EVENT_STREAMS,
  streams
})

export const _setEventLoading = (loading = false) => ({
  type: EVENT_LOADING,
  loading
})

export const removeStreamLocal = id => {
  return {
    type: EVENT_REMOVE_STREAM_LOCAL,
    id
  }
}

export const removeMessageLocal = id => {
  return {
    type: EVENT_REMOVE_MESSAGE,
    id
  }
}

export const setEventStats = stats => ({
  type: EVENT_GET_STATS,
  stats
})

export const setDonationId = donation => ({
  type: EVENTS_DONATIONS_SET_ID,
  donation
})

export const setDonations = donations => ({
  type: EVENT_SET_DONATIONS,
  donations
})

export const pushDonation = donation => ({
  type: EVENT_DONATIONS_PUSH,
  donation
})

export const removeDonation = donationId => ({
  type: EVENT_DONATIONS_REMOVE,
  donationId
})

export const setEventChats = chats => ({
  type: EVENT_SET_CHATS,
  chats
})

export const setChatLoading = chatLoading => ({
  type: EVENT_SET_CHATS_LOADING,
  chatLoading
})

export const pushEventChats = chats => ({
  type: EVENT_PUSH_CHATS,
  chats
})

export const setEventTickets = tickets => ({
  type: EVENT_TICKETS_SET,
  tickets
})

export const setEventTicketsLoading = eventTicketsLoading => ({
  type: EVENT_TICKETS_LOADING,
  eventTicketsLoading
})

export const setMyTickets = myTickets => ({
  type: MY_TICKETS_SET,
  myTickets
})

export const setMyTicketsLoading = myTicketsLoading => ({
  type: MY_TICKETS_LOADING,
  myTicketsLoading
})

export const getEvent = eventId => {
  return dispatch => {
    dispatch(_setEventLoading(true))
    const deferred = new Promise((resolve, reject) => {
      API.get(`/events/${eventId}`)
        .set('Content-Type', 'application/json')
        .then(response => {
          if (!response.ok) {
            throw Error(response.statusText)
          }
          if (response.body && response.body.msg) {
            if (response.body.msg === 'Event not found') {
              window.location.href = `/${eventId}`
            }
          }
          return response
        })
        .then(response => response.body)
        .then(response => {
          // response[0].sponsors = response[0].sponsors.map(sponsor => {
          //   sponsor = {
          //     ...sponsor,
          //     auctionCode: response[0].auction_code
          //   }
          //   return sponsor
          // })
          return response[0]
        })
        .then(data => {
          const isRehearsal =
            window.location.pathname.includes('&rehearsal=1') ||
            window.location.pathname.includes('&videomute=1')
          if (isRehearsal) {
            try {
              data.is_live = 1
              data.live_settings.is_live = true
            } catch (err) {
              console.log(err)
            }
          }
          resolve(
            serialize('event', data).then(response => {
              dispatch(setEvent(response))
              return response
            })
          )
        })
        .catch(err => {
          reject(err)
          console.log(err)
        })
        .finally(() => {
          dispatch(_setEventLoading(false))
        })
    })
    return deferred
  }
}

export const getEventDonations = eventId => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      API.get(`/donations/event/${eventId}`)
        .set('Content-Type', 'application/json')
        .then(response => {
          if (!response.ok) {
            throw Error(response.statusText)
          }
          return response
        })
        .then(response => response.body)
        .then(data => {
          resolve(
            serialize('donation', data).then(response => {
              // response.forEach(donation => {
              //   dispatch(setDonationId(donation))
              // })
              dispatch(setDonations(response))
              dispatch(setDonationsLoading(true))
              return response
            })
          )
        })
        .catch(err => {
          reject(err)
        })
    })
    return deferred
  }
}

export const joinUser = data => {
  return () => {
    return API.post(`/events/join`)
      .set('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8')
      .send(data)
      .then(response => {
        if (!response.ok) {
          throw Error(response.statusText)
        }

        return response
      })
      .then(response => response.body)
  }
}

export const donateAmount = (eid, userId, amount, anon) => {
  return () => {
    return API.post(`/donate`)
      .set('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8')
      .send({
        eid,
        user_id: userId,
        donate_amt: amount,
        anon: anon,
        purpose: 'general',
        origin: 'live'
      })
      .then(response => {
        if (!response.ok) {
          throw Error(response.statusText)
        }

        return response
      })
      .then(response => response.body)
  }
}

export const getEventStats = eid => {
  return dispatch => {
    return API.get(`/events/stats/${eid}`)
      .then(response => {
        if (!response.ok) {
          throw Error(response.statusText)
        }

        return response
      })
      .then(response => response.body)
      .then(response => {
        dispatch(setEventStats(response[0]))
        return response[0]
      })
  }
}

export const sendMessage = (eid, data) => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      return API.post(`/messages/chat/${eid}`)
        .set('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8')
        .send(data)
        .then(response => {
          if (!response.ok) {
            throw Error(response.statusText)
          }

          return response
        })
        .then(response => response.body)
        .then(response => {
          if (response.msg === 'message posted') {
            resolve(response)
          } else {
            reject({
              error: response.msg
            })
          }
        })
        .catch(err => {
          reject(err)
        })
    })
    return deferred
  }
}

export const getMessages = eid => {
  return dispatch => {
    return API.get(`/messages/stream/${eid}`)
      .then(response => {
        if (!response.ok) {
          throw Error(response.statusText)
        }
        return response
      })
      .then(response => response.body)
      .then(response => {
        return serialize('engagement', response).then(serializedResponse => {
          dispatch(setEventChats(serializedResponse))
          return serializedResponse
        })
      })
  }
}

export const getEventTickets = eid => {
  return dispatch => {
    dispatch(setEventTicketsLoading(true))
    return API.get(`/tickets/event/${eid}`)
      .then(response => {
        if (!response.ok) {
          throw Error(response.statusText)
        }

        return response
      })
      .then(response => response.body)
      .then(response => {
        return serialize('eventticket', response).then(serializedResponse => {
          dispatch(setEventTickets(serializedResponse))
          return serializedResponse
        })
      })
      .finally(() => dispatch(setEventTicketsLoading(false)))
  }
}

export const getUserTickets = (userId, eid) => {
  return dispatch => {
    dispatch(setMyTicketsLoading(true))
    return API.get(`/tickets/user/${userId}`)
      .query({
        eid,
        data: 'trim'
      })
      .then(response => {
        if (!response.ok) {
          throw Error(response.statusText)
        }
        return response
      })
      .then(response => response.body)
      .then(response => {
        return serialize('userticket', response).then(serializedResponse => {
          dispatch(setMyTickets(serializedResponse))
          return serializedResponse
        })
      })
      .finally(() => dispatch(setMyTicketsLoading(false)))
  }
}

export const deleteMessage = (messageId, eid) => {
  return dispatch => {
    return API.delete(`/messages/${messageId}`)
      .query({
        eid
      })
      .then(response => {
        //console.log(response)
        if (!response.ok) {
          throw Error(response.statusText)
        }

        return response
      })
      .then(response => response.body)
  }
}



// WEBPACK FOOTER //
// ./src/actions/event.js